import { CloudDone, CloudOff } from "@material-ui/icons";
import React, { useContext } from "react";

import { useForceRerender } from "../../../../hooks/useForceRerender";
import SignalRContext from "../../../../signalr/context";

interface Props {
    siteId: number;
}

export function SiteServiceStatusIndicator({ siteId }: Props) {
    // The `serviceStatus` map reference does not change when new data is received,
    // so this component will not re-render automatically.
    useForceRerender(2000);

    const { serviceStatus } = useContext(SignalRContext);

    const isSiteServiceOnline = serviceStatus.get(siteId);

    return isSiteServiceOnline ? <CloudDone /> : <CloudOff />;
}
